import router from '../router'
import axios from 'axios'
import { Toast } from 'mint-ui'

// 响应拦截
axios.interceptors.response.use(
  response => {
    // debugger
    const data = response.data
    const code = localStorage.getItem('code')
    if (data.code == 103) {
      Toast({
        message: 'cookie过期,请重新登录!',
        position: 'top',
        duration: 1500
      })
      router.push({
        name: 'Login',
        query: {
          code: code
        }
      })
    }
    return response
  },
  error => {
    if (error.response) {
      switch (error.response.status) {
        case 401:
        // 401 清除token信息并跳转到登录页面
        // store.commit('loginOut');
        // router.replace({
        //   path: 'login',
        //   query: { redirect: router.currentRoute.fullPath }
        // })
      }
    }
    return Promise.reject(error.response.data) // 返回接口返回的错误信息
  }
)

export default axios
